import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import {AuthService} from '../../services/authService';
import {UserMessageService} from '../../services/userMessageService';
import { CaseStudyAPI } from '../../services/caseStudyAPI';

@inject(AuthService, UserMessageService, Router, CaseStudyAPI)
export class CaseStudyListtCustomElement {
    constructor(authService, userMessageService, router, caseStudyApi) {

        this.authService = authService;
        this.userMessageService = userMessageService;
        this.router = router;
        this.caseStudyApi = caseStudyApi;
    }

    limitPages = [
        { id: 10, name: '10' },
        { id: 50, name: '50' },
        { id: 100, name: '100' },
      ];
    

    activate() {
        this.dataList = null;
        this.count = null;
        this.limit = 10;
        this.page = 1;
        this.sortBy = "CREATE_DATE";
        this.sortDir = "DESC";
        this.selectedlimitPages = 10;


        this.load();
    }

    detached() {
        if(this.refreshTimeout)
        {
            clearTimeout(this.refreshTimeout);
            this.refreshTimeout = null;
        }
    }


    load() {
        this.caseStudyApi.getList(
            this.page,
            this.limit,
            this.sortBy,
            this.sortDir,
            0,
            '',
            this.authService.getUser().token,
            this.saveLoadSuccess.bind(this),
            this.saveLoadError.bind(this));
    }


    saveLoadSuccess(data) {
        this.setData(data);
        if(this.refreshTimeout)
        {
            clearTimeout(this.refreshTimeout);
            this.refreshTimeout = null;
        }
        this.refreshTimeout = setTimeout(this.load.bind(this), 10000);

    }

    saveLoadError(msg) {
        this.userMessageService.setUserError("user", msg);
    }

    setData(data) {
        this.dataList = data.list;
        this.count = data.count;
        this.pages =  Math.floor(this.count / this.limit);
        this.pages = this.pages * this.limit <= this.count ? this.pages + 1 : this.pages;
    }

    rowClicked(item, $event) {
        console.log("Item is ",item);
        if($event.originalTarget && ($event.originalTarget.parentNode.classList.contains('tb_checkbox') || 
            $event.originalTarget.classList.contains('tb_checkbox')) )
            return true;
        if(item.status !=2 && item.status !=3 )
            this.router.navigate("video/caseStudy/" + item.id, true);
    }

    delete(item, $event) {
        $event.stopPropagation();
        if(confirm("Delete this video?")) {
            this.caseStudyApi.deleteVideo(
            item,
            this.authService.getUser().token,
            this.deleteSuccess.bind(this),
            this.saveLoadError.bind(this));
        }




    }

    deleteSuccess(data) {
        this.load();
        this.userMessageService.setUserMessage("user", "Video Successfully Deleted");

    }

    columnClicked(name) {
        if (this.sortBy == name) {
            if (this.sortDir == "ASC")
                this.sortDir = "DESC";
            else
                this.sortDir = "ASC";
            this.load();
        } else {
            this.sortBy = name;
            this.sortDir = "DESC";
            this.load();
        }
    }

    prev() {
        if (this.page > 1) {
            this.page--;
            this.dataList = null;
            this.load();
        }
    }

    next() {
        if (this.page < this.pages) {
            this.page++;
            this.dataList = null;
            this.load();
        }
    }

    limitChange() {
        if(this.limit != this.selectedlimitPages){
        this.limit = this.selectedlimitPages;
        this.dataList = null;
        this.load();
        }
      }

    isPublicChanged(item, $event) {
        
        $event.stopPropagation();    
        
        this.caseStudyApi.setPublic(
            item.id, 
            !item.public,  
            this.authService.getUser().token,
            (value) => { 
                item.public = value;
                if(!value)
                    item.featured = false;
            },
            this.saveLoadError.bind(this));
            
            
    }

    isFeaturedChanged(item, $event) {
        
        $event.stopPropagation();
        this.caseStudyApi.setFeatured(
            item.id, 
            !item.featured,  
            this.authService.getUser().token,
            (featured) => {item.featured = featured;},
            (error) => {item.featured = false; this.saveLoadError(error);});
    }

}
